import axios from 'axios'

export const api = axios.create({
  baseURL: 'https://admin.centraldagrama.com/wp-json/wp/v2',
  auth: {
    password: 'XL(y^JmUcTolp0$Snz5WCN1i',
    username: 'versatilnow'
  }
})

export const apiContact = axios.create({
  baseURL: 'https://admin.centraldagrama.com/wp-json/contact-form-7/v1/contact-forms',
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  auth: {
    password: 'XL(y^JmUcTolp0$Snz5WCN1i',
    username: 'versatilnow'
  }
})

export const apiSameOrigin = axios.create({
  baseURL: '/api',
})

export const apiAcf = axios.create({
  baseURL: 'https://admin.centraldagrama.com/wp-json/acf/v3',
  auth: {
    password: 'XL(y^JmUcTolp0$Snz5WCN1i',
    username: 'versatilnow'
  }
})

export const apiCg = axios.create({
  baseURL: 'https://admin.centraldagrama.com/wp-json/central-da-grama/v1',
  auth: {
    password: 'XL(y^JmUcTolp0$Snz5WCN1i',
    username: 'versatilnow'
  },
  headers: {
    'Content-Type': 'application/json'
  }
})
